import { i18n } from 'core/i18n';

import { OKMessage, MESSAGE_TYPE_ASSISTANT, MESSAGE_TYPE_INFORMATIVE } from 'commonsComponents/OKMessage'
import { OKInput } from 'commonsComponents/OKInput';
import DatePickerCustom from "components/datePickerCustom/datePickerCustom"
import MaskedIban from 'components/maskedIban/maskedIban'
import OKTooltip from 'components/commons/OKTooltip/OKTooltip'
import { LoadingSection } from 'commonsComponents/loadingSection'
import WebappRender from "components/conditionalRender/webappRender"
import ContactCenterRender from "components/conditionalRender/contactCenterRender"

import {
    DATE_PICKER_CUSTOM_DATE_FORMAT,
} from 'constants/commonsComponents'
import { MIN_DATE } from '../../constants/bringAccountConstants';
import { useSettingTransferStep } from '../../hooks/useSettingTransferStep';
import { getAssitantTitle } from '../../helpers/bringAccountHelper';
import { taggingDatePicker, taggingDatePickerError, taggingIban, taggingTooltip } from '../../helpers/bringAccountTagging';

import './settingTransferStep.scss';

const { FormattedText, formatText, getLanguage } = i18n;
const language = getLanguage();

const PickDateLabel = () => (
    <div className="transfer-account__setting-step__date-label">
        <FormattedText value="transfer_account-transfer_account_from_another_bank_step1_date_text" />
        <OKTooltip
            content={formatText('transfer_account-transfer_account_from_another_bank_step1_date_tooltip')}
            offset={[0, -10]}
            type="informative"
            onHover={taggingTooltip}
        />
    </div>
)

export const SettingTransferStep = ({ immBringAccount, immProfile, isOffice ,actions }) => {
    const {
        ibanNumber,
        executionDate,
        countryCode,
        ibanError,
        getEntityState,
        getIbanValidation,
    } = useSettingTransferStep({ immBringAccount, immProfile, actions });

    const { hasErrorIban } = getIbanValidation();
    const { isVisibleEntitySection, isLoadingEntity, entityName } = getEntityState()
    const dateError = formatText('transfer_account_cc-transfer_account_from_another_bank_step1_date_error');

    const handleChangeDate = (date) => {
        actions.setExecutionDate(date);
        taggingDatePicker(true);
    }

    const handleDatePickerError = () => {
        actions.setInvalidExecutionDate()
        taggingDatePickerError(dateError);
    }

    return (
        <div className="transfer-account__setting-step">
            <div className='transfer-account__setting-step__section'>
                <h1 className="transfer-account__setting-step__title">
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step1_subtitle" />
                </h1>
                <p className='transfer-account__setting-step__informative-section'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step1_subtitle_text" />
                </p>

                <WebappRender>
                    <div className='transfer-account__setting-step__disclaimer'>
                        <OKMessage type={MESSAGE_TYPE_INFORMATIVE}>
                            <FormattedText value="transfer_account-transfer_account_from_another_bank_step1_informative_message" />
                        </OKMessage>
                    </div>
                </WebappRender>

                <ContactCenterRender>
                    <div className='transfer-account__setting-step__disclaimer'>
                        <OKMessage
                            type={MESSAGE_TYPE_ASSISTANT}
                            title={getAssitantTitle(isOffice)}
                        >
                            <FormattedText value="transfer_account-transfer_account_from_another_bank_step1_informative_message" />
                        </OKMessage>
                    </div>
                </ContactCenterRender>

                <div>
                    <h5 className="transfer-account__setting-step__subtitle">
                        <FormattedText value="transfer_account-transfer_account_from_another_bank_step1_process_title" />
                    </h5>
                    <MaskedIban
                        id="inp_bringAccount_iban"
                        label={formatText('transfer_account-transfer_account_from_another_bank_step1_iban_number_title')}
                        doTaggingClickInput={taggingIban}
                        callback={actions.setIban}
                        instructionsMessage={formatText('transfer_account-transfer_account_from_another_bank_step1_iban_number_help_text')}
                        placeholder={null}
                        countryCode={countryCode}
                        iban={ibanNumber}
                        errorState={hasErrorIban}
                        errorMessage={ibanError}
                    />
                </div>
            </div>

            {isVisibleEntitySection && (
                <div className='transfer-account__setting-step__section'>
                    {
                        isLoadingEntity
                            ? (
                                <div className='transfer-account__setting-step__loading'>
                                    <LoadingSection />
                                </div>
                            )
                            : (
                                <OKInput
                                    label="Entidad"
                                    value={entityName}
                                    disabled
                                />
                            )
                    }
                </div>
            )}

            <div className='transfer-account__setting-step__section'>
                <h5 className="transfer-account__setting-step__subtitle">
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step1_date_title" />
                </h5>
                <p className='transfer-account__setting-step__informative-section'>
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step1_date_description" />
                </p>

                <ContactCenterRender>
                    <div className='transfer-account__setting-step__disclaimer'>
                        <OKMessage
                            type={MESSAGE_TYPE_ASSISTANT}
                            title={getAssitantTitle(isOffice)}
                        >
                            <FormattedText value="transfer_account_cc-transfer_account_from_another_bank_step1_disclaimer_2_cc" />
                        </OKMessage>
                    </div>
                </ContactCenterRender>

                <div className='transfer-account__setting-step__date-picker'>
                    <DatePickerCustom
                        label={<PickDateLabel />}
                        locale={language}
                        minDate={MIN_DATE}
                        selectedDate={executionDate}
                        callback={handleChangeDate}
                        errorMessage={dateError}
                        messageLessThanMinDateError={dateError}
                        messageMoreThanMinDateError={dateError}
                        dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        callbackError={handleDatePickerError}
                    />
                </div>
            </div>

            <div className='transfer-account__setting-step__disclaimer'>
                <OKMessage
                    type={__CONTACT_CENTER__ ? MESSAGE_TYPE_ASSISTANT : MESSAGE_TYPE_INFORMATIVE}
                    title={__CONTACT_CENTER__ && formatText('transfer_account_cc-transfer_account_from_another_bank_step1_disclaimer_title_cc')}
                >
                    <FormattedText value="transfer_account-transfer_account_from_another_bank_step1_informative_message_1" />
                </OKMessage>
            </div>
        </div>
    );
}

